import { usePostHog } from 'posthog-js/react';
import { useEffect, useRef } from 'react';
import { useProjectBaseInfo } from '@/features/projects/api/project-details';

export function useTrackProjectView(projectId: string) {
  const { data } = useProjectBaseInfo({ id: projectId });
  const posthog = usePostHog();

  const trackingRef = useRef({ startTime: Date.now() });

  useEffect(() => {
    return () => {
      if (!data) return;
      const duration = Date.now() - trackingRef.current.startTime;

      if (duration > 1000) {
        posthog?.capture('project_view', {
          tenant_id: data.tenantId,
          project_id: data.id,
          duration_in_ms: duration,
          duration_in_seconds: Math.round(duration / 1000),
          duration_in_minutes: Math.round(duration / 60_000),
        });
      }
    };
  }, [data, posthog]);
}
